import * as React from 'react';

import { IStyleConfig, mergeStyles, Tag } from '@cian/components';

const style = require('./index.css');

export interface ITagsGroupProps {
  tags: string[];
  commonTagStyle?: IStyleConfig;
  onDeleteClick(index: number): void;
  containerStyle?: IStyleConfig;
}

export const TagsGroup = (props: ITagsGroupProps) => {
  return props.tags.length ? (
    <div {...mergeStyles(style['container'], props.containerStyle)}>
      {props.tags.map((tag, i) => (
        <Tag
          key={i}
          tagStyles={
            mergeStyles(
              style['tag'],
              props.commonTagStyle,
              {
                padding: '2px 33px 4px 15px',
                fontSize: '13px',
                lineHeight: '1.43',
              },
              // tslint:disable-next-line: no-any
            ) as any
          }
          onDeleteClick={() => props.onDeleteClick(i)}
        >
          {tag}
        </Tag>
      ))}
    </div>
  ) : null;
};
